<template>
  <div>
    <div
      v-if="message.payload.type === 'image'"
      class="balloon balloon-image"
      @click.shift.left.exact="bubbleShift"
    >
      <img :src="link" @click="showImage(link)" />
      <deliver-reaction
        :message="message"
        :sessionId="sessionId"
        @onResendFile="resendFile"
        @onCancelDeliverFile="cancelDeliverFile"
      />
    </div>
    <div
      v-else-if="message.payload.type === 'audio'"
      class="balloon"
      @click.shift.left.exact="bubbleShift"
    >
      <audio controls>
        <source :src="link" />
        Your browser does not support HTML audio.
      </audio>
      <deliver-reaction
        :message="message"
        :sessionId="sessionId"
        @onResendFile="resendFile"
        @onCancelDeliverFile="cancelDeliverFile"
      />
    </div>
    <div
      v-else-if="message.payload.type === 'video'"
      class="balloon balloon-video"
      @click.shift.left.exact="bubbleShift"
    >
      <img
        v-if="message.payload.preview_url"
        :src="message.payload.preview_url"
        @click="playVideo(link)"
      />
      <video v-else width="300" controls>
        <source :key="link" :src="link" />
        Your browser does not support HTML video.
      </video>
      <deliver-reaction
        :message="message"
        :sessionId="sessionId"
        @onResendFile="resendFile"
        @onCancelDeliverFile="cancelDeliverFile"
      />
    </div>
    <div v-else class="balloon" @click.shift.left.exact="bubbleShift">
      <div class="balloon-file">
        <v-icon small class="ml-n1">mdi-paperclip</v-icon>
        <a v-if="link" :href="link" target="_blank">
          {{
            message.payload.message
              ? message.payload.message
              : message.payload.name
              ? message.payload.name
              : getLinkFlieName(message.payload)
          }}
        </a>
        <span v-else>
          {{
            message.payload.message
              ? message.payload.message
              : message.payload.name
              ? message.payload.name
              : getLinkFlieName(message.payload)
          }}
        </span>
      </div>
      <deliver-reaction
        :message="message"
        :sessionId="sessionId"
        @onResendFile="resendFile"
        @onCancelDeliverFile="cancelDeliverFile"
      />
    </div>
  </div>
</template>

<script>
import apiConversation from '@/apis/conversation'

import DeliverReaction from './deliverReaction'

export default {
  name: 'PayloadMedia',
  components: {
    DeliverReaction
  },
  props: {
    conversation: Object,
    sessionId: String
  },
  data() {
    return {
      message: {},
      sender: '',
      link: 'loading',
      isValid: false
    }
  },
  watch: {
    conversation: {
      immediate: true,
      deep: true,
      handler() {
        this.message = this.conversation.message
        this.sender = this.conversation.sender

        const url = this.message.payload.url
        this.getLink(url)
      }
    }
  },
  methods: {
    cancelDeliverFile({ deliverId, sessionId }) {
      this.$emit('onCancelDeliverFile', { deliverId, sessionId })
    },
    resendFile({ deliverId, sessionId }) {
      this.$emit('onResendFile', { deliverId, sessionId })
    },
    showImage(url) {
      return this.$parent.showImage(url)
    },
    playVideo(url) {
      return this.$parent.playVideo(url)
    },
    getLinkFlieName(payload) {
      if (!payload) return null

      if (payload && payload.file_name) return payload.file_name

      const filename = payload.url
        .split('?')[0]
        .split('/')
        .pop()
      return filename

      // let fileName = null
      // try {
      //   const url = new URL(text)
      //   const pathname = url.pathname
      //   fileName = pathname.substring(pathname.lastIndexOf('/') + 1)
      //   const extension = this.getExtension(fileName)
      //   if (!extension) {
      //     fileName = null
      //   }
      // } catch (_) {}
      // return fileName
    },
    async getLink(url) {
      if (url.includes('verify') || url.includes('admin')) {
        const realUrl = await apiConversation.getMediaUrl(url)
        this.link = realUrl.url
        this.isValid = realUrl.is_valid
      } else {
        this.isValid = true
        this.link = url
      }
    },
    bubbleShift(e) {
      this.$emit('debugPopup', this.conversation)
    }
  }
}
</script>
